module.exports = __webpack_public_path__ + "img/capital-nissan-wilm.a22076c7.png";